import React from 'react';

/** headless: apps/topmags/layouts/MainLayout/Footer/MoneySymbol. */
export default function MoneySymbol() {
  return (
    <span className="w-12 h-12 bg-gray-300 rounded-full hidden md:flex items-center justify-center">
      <span className="w-5 h-6 bg-gray-100 rounded-sm flex items-center justify-center font-bold text-gray-400 text-xs">
        $
      </span>
    </span>
  );
}
